<template>
  <div class="Container">
    <b-row
      ><b-col><h2>Device Flow Report</h2></b-col></b-row
    >
    <b-row
      ><b-col
        ><p class="explain">
          This report will show all devices which have not recorded a flow event
          within selected time period.
        </p></b-col
      ></b-row
    >
    <hr />
    <b-row>
      <b-col>Select Time Period to show</b-col>
    </b-row>
    <b-row>
      <b-col cols="3"
        ><b-form-select
          v-model="selectedfilter"
          :options="filteroptions"
          class="mb-3"
          value-field="item"
          text-field="name"
        ></b-form-select
      ></b-col>
      <b-col
        ><b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="applyfilter()"
          >Apply filter</b-button
        >
        <b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="clearfilter()"
          >Clear filter</b-button
        ></b-col
      ></b-row
    >
    <hr />
    <b-row class="text-center"
      ><b-col cols="1"></b-col><b-col><h4>Results</h4></b-col>
      <b-row
        ><b-col cols="1"
          ><img
            id="menuGraphic"
            align="right"
            src="../../assets/PDFIconSmall.png"
            v-on:click="createPDF()"/></b-col></b-row
    ></b-row>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
    ></b-pagination>
    <b-table
      id="ResultsTable"
      :fields="this.fields"
      :items="this.reportvalues"
      :per-page="perPage"
      :current-page="currentPage"
      empty-text="There are no results for current filter"
      no-border-collapse
      hover
      show-empty
      responsive
      small
      clas="text-center"
    >
      <template #thead-top>
        <b-tr>
          <b-th colspan="1"></b-th>
          <b-th colspan="4" class="text-center"
            ><p class="tableexplain">Last Recorded Flow</p></b-th
          >
        </b-tr>
      </template>
    </b-table>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <b-row 
          ><b-col cols="8" align-self="center"><h3>Clarence Flow Report</h3></b-col><b-col cols="4">
            <img
               src="../../assets/LogoOnly.png"
              style="height:120px; margin: none; padding: none;"/></b-col
        ></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Location: {{ this.selectedlocation }}</h5></b-col></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Generated: {{ this.now }}</h5></b-col></b-row>
        <hr />
        <b-table
          id="ResultsTable2"
          :fields="this.fields"
          :items="this.reportvalues"
          empty-text="There are no results for current filter"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          clas="text-center"
        >
          <template #thead-top>
            <b-tr>
              <b-th colspan="1"></b-th>
              <b-th colspan="4" class="text-center"
                ><p class="tableexplain">Last Recorded Flow</p></b-th
              >
            </b-tr>
          </template>
        </b-table>
        <hr />
        <b-row class="text-center"
          ><b-col>Generated from Seraph Protect</b-col></b-row
        >
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      ReportReady: true,
      perPage: 15,
      currentPage: 1,
      selectedfilter: 1,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      filteroptions: [
        { item: "1", name: "1 Day" },
        { item: "2", name: "2 Days" },
        { item: "3", name: "3 Days" },
        { item: "5", name: "5 Days" },
        { item: "7", name: "7 Days" },
      ],
      reportvalues: [],
      fields: [
        { key: "DeviceName", label: "Device" },
        { key: "RoomArea", label: "Room/Area" },
        { key: "LocationNote", label: "Location Note" },
        { key: "Probe1", label: "Probe1" },
        { key: "Probe2", label: "Probe2" },
        { key: "Probe3", label: "Probe3" },
        { key: "Probe4", label: "Probe4" },
      ],
      now: null,
    };
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "FlowReport.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
    rows() {
      return this.reportvalues.length;
    },
  },

  async mounted() {
    this.ReportReady = false
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/reports";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      Report: "devices_flow_order",
      Location: this.selectedlocation,
      Filters: [this.selectedfilter],
      RequestType: "",
      RequestVariable: "",
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {

        this.reportvalues = [];
        let responsedata = response.data.Values;
        let responseentries = Object.entries(responsedata);

        for (let i = 0; i < responseentries.length; i++) {
          let DeviceID = responseentries[i][0];
          let DeviceObject = Object.entries(responseentries[i][1]);
          let DeviceName = DeviceObject[0][1];
          let Probe1 = "";
          let Probe2 = "";
          let Probe3 = "";
          let Probe4 = "";

          if (DeviceID.includes("eui-")) {
            if (
              Array.isArray(responseentries[i][1].Probe1) &&
              responseentries[i][1].Probe1.length
            ) {
              let dateString = responseentries[i][1].Probe1[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe1 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe2) &&
              responseentries[i][1].Probe2.length
            ) {
              let dateString = responseentries[i][1].Probe2[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe2 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe3) &&
              responseentries[i][1].Probe3.length
            ) {
              let dateString = responseentries[i][1].Probe3[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe3 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe4) &&
              responseentries[i][1].Probe4.length
            ) {
              let dateString = responseentries[i][1].Probe4[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe4 = newdate;
            }

            let DeptFloor = responseentries[i][1].LocationInfo[0];

            let LocationNote = responseentries[i][1].LocationInfo[1];

            this.reportvalues.push({
              DeviceID: DeviceID,
              DeviceName: DeviceName,
              RoomArea: DeptFloor,
              LocationNote: LocationNote,
              Probe1: Probe1,
              Probe2: Probe2,
              Probe3: Probe3,
              Probe4: Probe4,
            });
          } else {
            //C1 Loop
            if (
              Array.isArray(responseentries[i][1].Probe1) &&
              responseentries[i][1].Probe1.length
            ) {
              let dateString = responseentries[i][1].Probe1[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe1 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe2) &&
              responseentries[i][1].Probe2.length
            ) {
              let dateString = responseentries[i][1].Probe2[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe2 = newdate;
            }

            let DeptFloor = responseentries[i][1].LocationInfo[0];
            let LocationNote = responseentries[i][1].LocationInfo[1];

            
              this.reportvalues.push({
                DeviceID: DeviceID,
                DeviceName: DeviceName,
                RoomArea: DeptFloor,
                LocationNote: LocationNote,
                Probe1: Probe1,
                Probe2: Probe2,
                Probe3: Probe3,
                Probe4: Probe4,
              });
            }
        }
        this.ReportReady = true
      });
  },

  methods: {
    createPDF() {
      let nowstamp = new Date();
      this.now = nowstamp.toLocaleString();
      this.$refs.html2pdf.generatePdf();
    },
    ReportLoaded() {
      if (this.ReportReady == true){
        this.$emit("ReportLoad", "Loaded");
      } else {
        this.$emit("ReportLoad", "Loading");
      }
    },

    applyfilter() {
      this.ReportReady = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "devices_flow_order",
        Location: this.selectedlocation,
        Filters: [this.selectedfilter],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.reportvalues = [];
          let responsedata = response.data.Values;
          let responseentries = Object.entries(responsedata);

          for (let i = 0; i < responseentries.length; i++) {
            let DeviceID = responseentries[i][0];
            let DeviceObject = Object.entries(responseentries[i][1]);
            let DeviceName = DeviceObject[0][1];
            let Probe1 = "";
            let Probe2 = "";
            let Probe3 = "";
            let Probe4 = "";
            let DeptFloor = responseentries[i][1].LocationInfo[0];
            let LocationNote = responseentries[i][1].LocationInfo[1];

            if (DeviceID.includes("eui-")) {
              if (
                Array.isArray(responseentries[i][1].Probe1) &&
                responseentries[i][1].Probe1.length
              ) {
                let dateString = responseentries[i][1].Probe1[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe1 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe2) &&
                responseentries[i][1].Probe2.length
              ) {
                let dateString = responseentries[i][1].Probe2[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe2 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe3) &&
                responseentries[i][1].Probe3.length
              ) {
                let dateString = responseentries[i][1].Probe3[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe3 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe4) &&
                responseentries[i][1].Probe4.length
              ) {
                let dateString = responseentries[i][1].Probe4[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe4 = newdate;
              }

              this.reportvalues.push({
                DeviceID: DeviceID,
                RoomArea: DeptFloor,
                LocationNote: LocationNote,
                DeviceName: DeviceName,
                Probe1: Probe1,
                Probe2: Probe2,
                Probe3: Probe3,
                Probe4: Probe4,
              });
            } else {
              
              if (
              Array.isArray(responseentries[i][1].Probe1) &&
              responseentries[i][1].Probe1.length
            ) {
              let dateString = responseentries[i][1].Probe1[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe1 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe2) &&
              responseentries[i][1].Probe2.length
            ) {
              let dateString = responseentries[i][1].Probe2[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe2 = newdate;
            }

            let DeptFloor = responseentries[i][1].LocationInfo[0];
            let LocationNote = responseentries[i][1].LocationInfo[1];

            
              this.reportvalues.push({
                DeviceID: DeviceID,
                DeviceName: DeviceName,
                RoomArea: DeptFloor,
                LocationNote: LocationNote,
                Probe1: Probe1,
                Probe2: Probe2,
                Probe3: Probe3,
                Probe4: Probe4,
              });
          }
        }
          this.ReportReady = true
        });
    },

    clearfilter() {
      this.selectedfilter = 1;
      this.ReportReady = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "devices_flow_order",
        Location: this.selectedlocation,
        Filters: [this.selectedfilter],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.reportvalues = [];
          let responsedata = response.data.Values;
          let responseentries = Object.entries(responsedata);

          for (let i = 0; i < responseentries.length; i++) {
            let DeviceID = responseentries[i][0];
            let DeviceObject = Object.entries(responseentries[i][1]);
            let DeviceName = DeviceObject[0][1];
            let Probe1 = "";
            let Probe2 = "";
            let Probe3 = "";
            let Probe4 = "";
            let DeptFloor = responseentries[i][1].LocationInfo[0];
            let LocationNote = responseentries[i][1].LocationInfo[1];


            if (DeviceID.includes("eui-")) {
              if (
                Array.isArray(responseentries[i][1].Probe1) &&
                responseentries[i][1].Probe1.length
              ) {
                let dateString = responseentries[i][1].Probe1[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe1 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe2) &&
                responseentries[i][1].Probe2.length
              ) {
                let dateString = responseentries[i][1].Probe2[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe2 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe3) &&
                responseentries[i][1].Probe3.length
              ) {
                let dateString = responseentries[i][1].Probe3[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe3 = newdate;
              }
              if (
                Array.isArray(responseentries[i][1].Probe4) &&
                responseentries[i][1].Probe4.length
              ) {
                let dateString = responseentries[i][1].Probe4[0];
                let splitDate = dateString.split("-");
                let newdate =
                  splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
                Probe4 = newdate;
              }

              this.reportvalues.push({
                DeviceID: DeviceID,
                DeviceName: DeviceName,
                RoomArea: DeptFloor,
                LocationNote: LocationNote,
                Probe1: Probe1,
                Probe2: Probe2,
                Probe3: Probe3,
                Probe4: Probe4,
              });
            } else {
              //C1 Loop

               if (
              Array.isArray(responseentries[i][1].Probe1) &&
              responseentries[i][1].Probe1.length
            ) {
              let dateString = responseentries[i][1].Probe1[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe1 = newdate;
            }
            if (
              Array.isArray(responseentries[i][1].Probe2) &&
              responseentries[i][1].Probe2.length
            ) {
              let dateString = responseentries[i][1].Probe2[0];
              let splitDate = dateString.split("-");
              let newdate =
                splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];
              Probe2 = newdate;
            }

            let DeptFloor = responseentries[i][1].LocationInfo[0];
            let LocationNote = responseentries[i][1].LocationInfo[1];

            
              this.reportvalues.push({
                DeviceID: DeviceID,
                DeviceName: DeviceName,
                RoomArea: DeptFloor,
                LocationNote: LocationNote,
                Probe1: Probe1,
                Probe2: Probe2,
                Probe3: Probe3,
                Probe4: Probe4,
              });
            }
          }
          this.ReportReady = true
        });
        
    },
  },

  watch: {
    ReportReady() {
    this.ReportLoaded();
    }
  },
};
</script>

<style scoped>
p.explain {
  color: gray;
  font-size: small;
}
p.tableexplain {
  color: gray;
  font-size: small;
  margin-bottom: 1px;
}
#menuGraphic {
  cursor: pointer;
}
</style>
